<div class="page-content-wrapper">
    <div class="card rounded-3 border-1 shadow">
    <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
        <h2 class="text-s fw-bold">Asset Information</h2>
        <button
        type="button"
        class="btn btn-dark btn-sm text-xxs fw-bold rounded-3 shadow"
        @click="$router.go(-1)"
        >
        <i class="fas fa-arrow-left"></i> Back
        </button>
    </div>

    <div class="card-body">
        <div class="row">
        <div class="col-12">
            <div class="decorative-card rounded-small bg-light">
            <div class="p-3">
                <div class="row align-items-start">                                 
                <div v-if="asset_info.uploaded_image_url" class="col-md-3">
                    <img 
                    :src="asset_info.uploaded_image_url" 
                    class="img-fluid rounded shadow-sm"
                    :alt="asset_info.asset_name"
                    style="max-height: 250px; object-fit: cover;"
                    />
                </div>
        
                <div :class="asset_info.uploaded_image_url ? 'col-md-6' : 'col-md-9'">
                    <div class="d-flex align-items-start justify-content-between mb-2">
                    <div class="w-100">
                        <span class="badge bg-primary text-white text-xxs mb-2">
                        Asset Information
                        </span>
                        <p class="mb-2 text-s fw-bold">
                        Asset: {{ asset_info.asset_name }}
                        </p>
                    </div>
                    </div>
                    
                    <div v-if="asset_info.asset_description" class="mb-2">
                    <span class="text-xs fw-bold">Description:</span>
                    <p class="text-xs text-muted mb-0">{{ asset_info.asset_description }}</p>
                    </div>
                    
                    <div v-if="asset_info.asset_type" class="text-xs mb-1">
                    <span class="fw-bold">Type:</span>
                    <span class="ms-2 text-muted">{{ asset_info.asset_type }}</span>
                    </div>
                    
                    <div v-if="asset_info.date_created" class="text-xs mb-1">
                    <span class="fw-bold">Created:</span>
                    <span class="ms-2 text-muted">{{ formatDate(asset_info.date_created) }}</span>
                    </div>
                    
                    <div class="text-xs mb-1">
                    <span class="fw-bold">Status:</span>
                    <span class="ms-2">
                        <span v-if="asset_info.is_active" class="badge bg-success text-white text-xxs">Active</span>
                        <span v-else class="badge bg-secondary text-white text-xxs">Inactive</span>
                    </span>
                    </div>
                    
                    <div v-if="workflow_data.workflow_name" class="text-xs mb-1">
                    <span class="fw-bold">Workflow:</span>
                    <span class="ms-2 text-muted">{{ workflow_data.workflow_name }}</span>
                    </div>
                    
                    <div v-if="qr_code_data.link" class="text-xs mb-1">
                    <span class="fw-bold">Link:</span>
                    <a 
                        :href="qr_code_data.link" 
                        target="_blank" 
                        class="ms-2 text-primary text-decoration-none"
                        rel="noopener noreferrer"
                    >
                        <i class="fas fa-external-link-alt me-1"></i>
                        View
                    </a>
                    </div>
                </div>
                
                <!-- QR Code Section -->
                <div class="col-md-3 text-center">
                    <p class="text-xs fw-bold mb-3">Asset QR Code</p>
                    
                    <!-- QR Code Container -->
                    <div class="qr-code-wrapper mb-3">
                    <div v-if="qr_code_data.qr_code" class="qr-code-container bg-white p-3 rounded shadow-sm d-inline-block">
                        <img 
                        :src="qr_code_data.qr_code" 
                        class="img-fluid"
                        alt="QR Code"
                        style="width: 150px; height: 150px;"
                        />
                    </div>
                    <div v-else class="qr-code-placeholder bg-white rounded shadow-sm d-inline-flex align-items-center justify-content-center">
                        <i class="fas fa-qrcode fa-3x text-muted"></i>
                    </div>
                    </div>
                    
                    <!-- Download Button -->
                    <button 
                    v-if="qr_code_data.qr_code && qr_code_data.id"
                    @click="downloadQRCode" 
                    class="btn bg-green text-white text-xxs fw-bold rounded-small shadow-sm px-3 py-2"
                    >
                    <i class="fas fa-download me-1"></i> Download QR
                    </button>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
</div>